import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

import { TextField, Typography, Box, Button, Paper, Grid, Alert, Card } from "@mui/material";

const ManageSubscription = () => {
    const [monthlyPrice, setMonthlyPrice] = useState('');
    const [yearlyPrice, setYearlyPrice] = useState('');
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState('');

    useEffect(() => {
        const fetchPrices = async () => {
            try {
                const monthlyRef = doc(db, 'subscriptionManagement', 'monthly');
                const yearlyRef = doc(db, 'subscriptionManagement', 'yearly');

                const monthlySnap = await getDoc(monthlyRef);
                const yearlySnap = await getDoc(yearlyRef);

                if (monthlySnap.exists() && yearlySnap.exists()) {
                    setMonthlyPrice(monthlySnap.data().price);
                    setYearlyPrice(yearlySnap.data().price);
                } else {
                    console.error('One or both documents do not exist.');
                }
            } catch (err) {
                console.error('Error fetching prices:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchPrices();
    }, []);

    const handleUpdate = async () => {
        setStatus('Updating...');
        try {
            await setDoc(doc(db, 'subscriptionManagement', 'monthly'), {
                price: Number(monthlyPrice),
            });
            await setDoc(doc(db, 'subscriptionManagement', 'yearly'), {
                price: Number(yearlyPrice),
            });
            setStatus('Prices updated successfully!');
        } catch (err) {
            console.error('Error updating prices:', err);
            setStatus('Failed to update prices.');
        }
    };

    // if (loading) return <p>Loading prices...</p>;


    return (
        <div
            style={{
                width: "100%",
                padding: 40,
                paddingRight: 20,

                backgroundColor: "#212C62",
            }}
        >

            <Card style={{ padding: 50, borderRadius: 10 }}>
                <div className="row d-flex justify-content-between">
                    <div className="col-6 mb-4 py-4">
                        <h1 className="" style={{ textAlign: "left", color: "#212C62" }}>
                            <b>Manage Subscription Plan</b>
                        </h1>


                    </div>




                </div>

                {loading ? <p>Loading prices...</p>:
                <Box
                    component={Paper}
                    elevation={3}
                    sx={{
                        maxWidth: 500,
                        mx: "auto",
                        my: 4,
                        p: 4,
                        borderRadius: 3,
                        backgroundColor: "#f9fafc",
                    }}
                >
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#212C62" }}>
                        Subscription Price Management
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Monthly Price ($)"
                                value={monthlyPrice}
                                onChange={(e) => setMonthlyPrice(e.target.value)}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Yearly Price ($)"
                                value={yearlyPrice}
                                onChange={(e) => setYearlyPrice(e.target.value)}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={handleUpdate}
                                sx={{
                                    py: 1.2,
                                    backgroundColor: "#212C62",
                                    color: "#fff",
                                    '&:hover': {
                                        backgroundColor: "#1a2451",
                                    },
                                }}
                            >
                                Update Prices
                            </Button>
                        </Grid>

                        {status && (
                            <Grid item xs={12}>
                                <Alert severity={status.includes("successfully") ? "success" : "error"}>
                                    {status}
                                </Alert>
                            </Grid>
                        )}
                    </Grid>
                </Box>}
            </Card>
        </div>
    );
};

export default ManageSubscription;
